module.exports = __webpack_public_path__ + "static/media/logo.f5f07dce.png";